module.exports = __webpack_public_path__ + "img/logo-footer-1.4c85ce54.svg";